import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Draggable, Droppable } from 'react-beautiful-dnd';
import CloseIcon from 'mdi-react/CloseIcon';
import { Alert } from 'reactstrap';
import { SHIFT_ITEM_TYPE } from '../../../shared/utils/constants';

const DroppableGrid = (props) => {
  const { t, timeTable, onRemoveCard } = props;

  return (
    <div className="timetable-container">
      <div className="d-flex w-100">
        {Object.values(timeTable)[0] && Object.values(timeTable)[0].length ? (
          <>
            {Object.keys(timeTable).map((day) => (
              <div
                key={t(`general.weekdays.ordinal.${day}`)}
                className="d-flex flex-column mr-1"
              >
                <div className="day-of-week">
                  <span>{t(`general.weekdays.ordinal.${day}`)}</span>
                </div>
                {timeTable[day].map((item) => (
                  <>
                    {item.shiftItem.type !== SHIFT_ITEM_TYPE.INTERVAL ? (
                      <div key={item.uuid} className="day-container">
                        <Droppable
                          droppableId={`${day}.${item.shiftItem.startAt}`}
                          isDropDisabled={!!item.shiftItem.card.subject}
                        >
                          {(provided) => (
                            <>
                              <div
                                ref={provided.innerRef}
                                className="day-droppable"
                              >
                                <Draggable
                                  draggableId="0"
                                  index={0}
                                  isDragDisabled
                                >
                                  {(providedx) => (
                                    <div
                                      ref={providedx.innerRef}
                                      className={
                                        item.shiftItem.card &&
                                        item.shiftItem.card.subject
                                          ? 'draggable-card complete'
                                          : 'd-none'
                                      }
                                    >
                                      {item.shiftItem.card &&
                                        item.shiftItem.card.subject && (
                                          <>
                                            <div className="d-flex justify-content-between p-1">
                                              <span className="label">
                                                {
                                                  item.shiftItem.card.subject
                                                    .name
                                                }
                                              </span>
                                              <button
                                                className="panel__btn"
                                                type="button"
                                                onClick={() =>
                                                  onRemoveCard(
                                                    `${day}.${item.shiftItem.startAt}`,
                                                    item.shiftItem.card
                                                  )
                                                }
                                              >
                                                <CloseIcon />
                                              </button>
                                            </div>
                                            {item.shiftItem.card.professor && (
                                              <>
                                                <span className="info-content">
                                                  {
                                                    item.shiftItem.card
                                                      .professor.name
                                                  }
                                                </span>
                                                <span className="info-content">
                                                  {
                                                    item.shiftItem.card.room
                                                      .name
                                                  }
                                                </span>
                                              </>
                                            )}
                                          </>
                                        )}
                                    </div>
                                  )}
                                </Draggable>
                                {provided.placeholder}
                              </div>
                            </>
                          )}
                        </Droppable>
                      </div>
                    ) : (
                      <div key={item.uuid} className="interval-container">
                        <span>
                          {t('general.interval')} {item.shiftItem.startAt}
                        </span>
                      </div>
                    )}
                  </>
                ))}
              </div>
            ))}
          </>
        ) : (
          <Alert className="text-center w-100 m-0" color="danger">
            {t('notifications.selected-shift-filled-incorrectly')}
          </Alert>
        )}

        <div className="timetable-column-hour">
          {Object.keys(timeTable).length
            ? timeTable[
                Object.keys(timeTable)[Object.keys(timeTable).length - 1]
              ].map(({ shiftItem }) => (
                <div
                  key={shiftItem.startAt}
                  className={
                    shiftItem.type === SHIFT_ITEM_TYPE.CLASS
                      ? 'class'
                      : 'interval'
                  }
                >
                  <span>{shiftItem.startAt}</span>
                </div>
              ))
            : null}
        </div>
      </div>
    </div>
  );
};

DroppableGrid.propTypes = {
  t: PropTypes.func.isRequired,
  onRemoveCard: PropTypes.func.isRequired,
  timeTable: PropTypes.shape(PropTypes.arrayOf(PropTypes.shape)).isRequired,
};

export default withTranslation('common')(DroppableGrid);
